import { Component, Input } from '@angular/core';

import { NgxOrgChartComponent } from '@ahmedaoui/ngx-org-chart';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FooterComponent } from '../../core/layout/components/footer/footer.component';
import { ToolbarComponent } from '../../core/layout/components/toolbar/toolbar.component';
import { DecideService } from '../decide/services/decide.service';
import { IMock } from '../interfaces/decision.interface';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'app-prepare',
  standalone: true,
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
  imports: [
    FormsModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    MatRadioModule,
    MatButtonModule,
    FooterComponent,
    ToolbarComponent,
    ReactiveFormsModule,
    NgxOrgChartComponent,
  ],
  templateUrl: './prepare.component.html',
  styleUrl: './prepare.component.scss',
})
export class PrepareComponent {
  @Input() tabGroup!: MatTabGroup;

  // ORGANIZATION CHART
  nodes: any[] = [];
  zoom = 1;

  // LIST OF DECISIONS
  decision: string = '';
  decisionList = Array(5).fill(0);

  // CREDIBILITY
  progressBars = Array(10).fill(0); // Creates an array with 10 elements
  credibility = 3;

  // USEFUL WEEKS
  dashArray: string = '';
  dashOffset: string = '';
  weeksProgress: number = 40;
  maxWeeks: number = 80;

  // CRITICAL MASS
  progressCriticalMass = Array(10).fill(0); // Creates an array with 10 elements
  criticalMass = 7;

  //ADOPTION STAGE
  stepperStatus = [false, false, false];

  constructor(private service: DecideService) {}

  data!: IMock;
  startTest(): void {
    // Enable the Decide tab
    const decideTab = this.tabGroup._tabs.toArray()[1];
    decideTab.disabled = false;

    // Navigate to the Decide tab
    this.tabGroup.selectedIndex = 1;
  }
  ngOnInit(): void {
    this.service.decisionsSubject.subscribe((data) => {
      if (data) {
        this.data = data;
        this.nodes = [data.organisation_chart];
      }
    });
  }

  // ORGANIZATION CHART
  zoomOrganizationChart(zoom: number): void {
    this.zoom = this.zoom + zoom;
  }
}
